import { Lock } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

/**
 * Bandeau posé en tête d'un écran dont une capacité est verrouillée sur le plan
 * gratuit (#155). Il explique le grisage et renvoie vers la facturation — le
 * refus, lui, reste appliqué côté API, ce bandeau n'est que la courtoisie visuelle.
 */
function PlanLockedBanner({ message }: { message: string }) {
  const { t } = useTranslation()

  return (
    <div className="flex items-start gap-3 rounded-lg border border-dashed border-border bg-muted/40 p-4">
      <Lock className="mt-0.5 size-5 shrink-0 text-muted-foreground" />
      <div className="flex flex-col gap-1 text-sm">
        <p className="text-muted-foreground">{message}</p>
        <Link
          to="/back-office/billing"
          className="w-fit font-medium text-primary underline-offset-4 hover:underline"
        >
          {t('plan.locked.cta')}
        </Link>
      </div>
    </div>
  )
}

export default PlanLockedBanner
